import type { Booking, Guest } from "@/types/camping";

export function formatGuestName(guest: Pick<Guest, "last_name" | "first_name">): string {
  return `${guest.last_name}, ${guest.first_name}`;
}

/** Bevorzugt API-Feld guest_name; sonst Lookup in geladener Gästeliste. */
export function resolveGuestName(
  guestId: string,
  options?: {
    booking?: Pick<Booking, "guest_name"> | null;
    guests?: Guest[];
  },
): string {
  const fromApi = options?.booking?.guest_name;
  if (fromApi) return fromApi;
  const g = options?.guests?.find((x) => x.id === guestId);
  if (g) return formatGuestName(g);
  return guestId.slice(0, 8);
}
